/** Mention of the mix-mode input: [[{"value":"12","displayValue":"Jean",...}]] */
const MENTION = /\[\[(\{[\s\S]*?\})\]\]/g;
/** Content written by the server (e-mail sent...) is HTML; a note typed in the input is plain text */
const HTML_HINT = /<(br|hr|p|div|strong|em|b|i|u|blockquote|ul|ol|li|span|a)\b[^>]*>/i;

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function renderText(value: string, isHtml: boolean): string {
  return isHtml ? value : escapeHtml(value).replace(/\r?\n/g, '<br>');
}

function renderMention(json: string, myId: number): string {
  try {
    const data = JSON.parse(json);
    const name = String(data?.displayValue ?? data?.value ?? '');
    const isMe = myId !== undefined && String(data?.userID ?? data?.value) === String(myId);
    return `<span class="note-mention${isMe ? ' note-mention-me' : ''}">@${escapeHtml(name)}</span>`;
  } catch {
    return escapeHtml(`[[${json}]]`);
  }
}

/**
 * Note content as HTML for [innerHTML] (Angular sanitizes it again): text escaped with its line breaks, mentions
 * as chips. It was a whole read-only tagify input per note.
 */
export function renderNoteContent(content: string, myId?: number): string {
  if (!content) {
    return '';
  }
  const isHtml = HTML_HINT.test(content);
  let html = '';
  let last = 0;
  for (const match of content.matchAll(MENTION)) {
    html += renderText(content.slice(last, match.index), isHtml);
    html += renderMention(match[1], myId);
    last = (match.index ?? 0) + match[0].length;
  }
  html += renderText(content.slice(last), isHtml);
  return html;
}

/**
 * Note content as plain text (system notification of the browser, tooltips): mentions as @Name, HTML tags removed,
 * spaces collapsed. The raw mention JSON was shown: [[{"userID":...,"displayValue":"xmz"}]] test.
 */
export function noteContentToText(content: string): string {
  if (!content) {
    return '';
  }
  const withMentions = content.replace(MENTION, (_, json: string) => {
    try {
      const data = JSON.parse(json);
      return '@' + String(data?.displayValue ?? data?.value ?? '');
    } catch {
      return '';
    }
  });
  const text = HTML_HINT.test(withMentions)
    ? (new DOMParser().parseFromString(withMentions.replace(/<br\s*\/?>/gi, '\n'), 'text/html').body.textContent ?? '')
    : withMentions;
  return text.replace(/[ \t]+/g, ' ').replace(/\s*\n\s*/g, '\n').trim();
}
